export enum CipoExceptionCode {
        Unknown = 0,
        Error,
        Database,
        FieldInvalidEmailAddress,
        FieldUrlAddress,
        FieldMaxLength,
        FieldMinLength,
        FieldRequired,
        FieldNeedsToBeChecked,
        FieldMinValue,
        InvalidText,
        InvalidNumber,
        InvalidDate,
        InvalidBoolean,
        InvalidAttachments,
        InvalidType,
        InvalidDecimal,
        InvalidInteger,
        InvalidDateTime,
        InvalidTime,
        AlreadyExists,
        NotFound,
        NotAllowed,
        InUse,
        NotDeleted,
        NotDraft,
        NotAdded,
        NotCreated,
        InvalidFormat,
        NotAssigned,
        StartDateAfterEndDate,
        NothingWasChanged,
        Required,
        InvalidInviteCode,
        InviteCodeExpired,
        NotAgreeToTermsAndConditions,
        AnotherTenantUsesThisName,
        TenantCannotBeDeletedOrDeactivated,
        InvalidUser,
        InvalidPassword,
        InvalidNewPassword,
        NotAssignedUser,
        NotAllowedAssignedUser,
        AlreadyAssigned,
        UserDisabled,
        UserNotFound,
        MultipleUsersSent,
        NotFoundBaseFolder,
        NotFoundDestinationFolder,
        NotFoundFile,
        FileToBig,
        FileNotOfTypeOfCurrentVersion,
        ChildFolderOnDifferentContract,
        ChildFolderWithFileOnDifferentContract,
        FolderAlreadyExists,
        FolderNotEmpty,
        EmptyFileData,
        ParentIsPerContract,
        DestinationFolderIsPerContract,
        ExistingGlobalChildren,
        PaymentPeriodBeforeContract,
        PaymentPeriodAfterContract,
        PaymentPeriodEndDateAlreadyCovered,
        PaymentPeriodMissingInContract,
        PaymentPeriodMissingUnknownReason,
        ProgressPaymentHasNoPayments,
        ExistingProgressPayments,
        ProgressPaymentNoContract,
        ProgressPaymentHasPendingPaymentsBefore,
        ProgressPaymentHasCompletedPaymentsAfter,
        PaymentExceed100Percent,
        RemoveProgressPaymentDataListFields,
        SOVIHasRevisionNotClosed,
        PaymentNotAllowed,
        NotAllowedOnZero,
        PercentOnZeroAmount,
        InvalidFormulaExpression,
        InvalidElementId,
        ParentDataSourceMissing,
        MultipleParentDataSource,
        ParentDataSourceMissingDefaultValue,
        DifferentValueFromParent,
        MissingListColumn,
        MissingListCodeColumn,
        TemplateNotFound,
        InvalidTemplate,
        InvalidHTML,
        DocumentInProcess,
        InvalidNonBindingSignature,
        InvalidPeopleToSign,
        InvalidDocument,
        HelloSignRequestFailed,
        HelloSignDocumentAvailable,
        InvalidNonBindingImage,
        HelloSignDocumentNotAvailable,
        SignatureTokenNotValid,
        SignatureEmpty,
        AzureAD,
        AzureADB2CSignUpInvitation,
        MultipleParentStates,
        UnavailableParentStates,
        UnavailableChildStates,
        CurrentModuleNotInRelation,
        ExistingPartialPayment,
        ExistingPPRelation,
        TokenNotSupplied,
        InvalidToken,
        InvalidCall,
        ModuleIdNotFound,
        ModuleNotAllowed,
        InvalidContract,
        ContractTypeNotFound,
        ProjectTypeNotFound,
        ProjectContractTypeNotMatch,
        ProjecttNumberNotFound,
        DocumentNumberNotFound,
        InvalidStateId,
        InvalidStartDate,
        InvalidCompletionDate,
        InvalidSchedule,
        InvalidFinancialSchedule,
        SOVIsEmpty,
        SOVImportError,
        UpdateNotAllowed,
        DeleteNotAllowed,
        PrintNotAllowed,
        ActionNotAllowed,
        MultipleStartScreen,
        AdjustmentCannotBeRecurringAndAccruing,
        AdjustmentNeitherAmountNorPercentageSpecified,
        AdjustmentBothAmountAndPercentageSpecified,
        AdjustmentAccrualPeriodRequiredWhenAccruing,
        AdjustmentAccrualValueIsPercentage,
        AdjustmentReleaseTooMuch,
        AdjustmentReleaseNothingRemaining,
        NotAllowedToChangeAdjustmentType,
        NotAllowedToChangeAdjustmentFrequency,
        NotAllowedToChangeAdjustmentCategory,
        ReleasedAmountExceedTotalAmount,
        NotAllowedAdjustmentToBeRetained,
        InUseOneTimeAdjustment,
        FieldNotFound,
        ScreenNotFound,
        FieldAlreadyExistOnScreen,
        FieldUsedOnScreen,
        InvalidElement,
        NotFoundTableField,
        ParentFieldNotTable,
        DifferentFieldType,
        SyncFieldsDoesNotMatch,
        DisplayTypeNotSet,
        TableFieldsNotSupplied,
        TableFieldNotAllowed,
        TableFieldsRemoveError,
        TableFieldsCreateOrUpdateError,
        RestrictionNotValidated,
        NotAllowedCharacters,
        MultipleTemplateId,
        InvalidDocumentNumber,
        InvalidReviseDocument,
        DocumentNumberAlreadyExists,
        TemplateNotAllowedOnContract,
        AlreadyExistingDocumentNumber,
        AlreadyExistingPreset,
        DocumentNotFoundContract,
        DocumentNotFoundModule,
        SyncProcessOpen,
}